export default __webpack_public_path__ + "static/media/lightbulb-regular.f46eecaa.svg";